// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { Milkability, MilkabilitySchema } from 'api/gen/Milkability';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PageMetadata, PageMetadataSchema } from 'api/gen/PageMetadata';

const requiredPart = t.interface({
  content: t.union([t.array(MilkabilitySchema), t.null]),
  page: t.union([PageMetadataSchema, t.null]),
});

export const PagedModelMilkabilitySchema = excess(requiredPart);

export interface PagedModelMilkability extends t.TypeOf<typeof PagedModelMilkabilitySchema> {}
